import React, { useState, useEffect } from 'react';
import './LoginScreen.css';
import { API_ENDPOINTS } from './config/apiConfig';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import LoginViews from './LoginViews'; // <-- Importar el nuevo componente
import { plans, Plan } from './config/plansConfig'; // <-- IMPORTAR DESDE EL LUGAR CORRECTO

// Para el selector de país
const countryCodes = [
  { code: '+1', name: 'USA' },
  { code: '+44', name: 'UK' },
  { code: '+52', name: 'México' },
  { code: '+54', name: 'Argentina' },
  { code: '+34', name: 'España' },
  { code: '+57', name: 'Colombia' },
  { code: '+51', name: 'Perú' },
];

type View = 'default' | 'forgot-password' | 'reset-password';
// Importamos todas las props que este componente necesitará del padre (LoginScreen)

// El componente ya no recibe 'onLoginSuccess' como prop
const LoginScreen: React.FC = () => {
  const { login } = useAuth(); // Usamos el hook para obtener la función de login del contexto
  const [view, setView] = useState<View>('default');
  const [activeTab, setActiveTab] = useState<'login' | 'register'>('login');
  const [isLoading, setIsLoading] = useState(false);
// --- NUEVO ESTADO PARA EL FLUJO DE REGISTRO ---
  const [registrationStep, setRegistrationStep] = useState<'plans' | 'form'>('plans');
  const [selectedPlan, setSelectedPlan] = useState<Plan | null>(null);
  // --- Estados para Login ---
  const [loginUsername, setLoginUsername] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [loginError, setLoginError] = useState('');

  const [registerSuccess, setRegisterSuccess] = useState('');
  const [registerError, setRegisterError] = useState('');
  
  // --- Estados para Registro ---
  const [fullName, setFullName] = useState('');
  const [countryCode, setCountryCode] = useState(countryCodes[6].code);
  const [phone, setPhone] = useState('');
  const [registerEmail, setRegisterEmail] = useState('');
  const [registerPassword, setRegisterPassword] = useState('');
  const [usernameError, setUsernameError] = useState('');

  const [recoveryEmail, setRecoveryEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [token, setToken] = useState<string | null>(null);
    
useEffect(() => {
    document.title = `${process.env.REACT_APP_WEBSITE_TITLE || 'Login'}`;
    const params = new URLSearchParams(window.location.search);
    const urlToken = params.get('token');
    if (urlToken) {
      setToken(urlToken);
      setView('reset-password');
    }
  }, []);

  const handlePlanSelection = (plan: Plan) => {
    setSelectedPlan(plan);
    if (plan.id === 'free') {
      // Si es gratis, vamos directo al formulario de registro
      setRegistrationStep('form');
    } else {
      // Si es de pago, mostramos una alerta temporal
      toast.info("La compra de planes durante el registro se habilitará pronto. Por ahora, regístrate gratis y actualiza tu plan más tarde.");
      // Opcionalmente, podrías deshabilitar los botones de planes de pago
    }
  }
  // --- FUNCIÓN DE LOGIN ACTUALIZADA ---
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setLoginError('');

    try {
      const requestBody = {
        username: loginUsername,
        password: loginPassword,
      };
      //console.log("Enviando credenciales a la API:", JSON.stringify(requestBody, null, 2));
      const response = await fetch(API_ENDPOINTS.login, {
        method: 'POST', // Vuelve a ser un método POST
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.detail || data.message || 'Credenciales inválidas.');
      }

      // Validamos que la respuesta contenga los datos esperados
      if (!data.access_token || !data.username || !data.role || !data.fecha_i || !data.fecha_f) {
          throw new Error("La respuesta de la API es incompleta.");
      }
      
      // Llamamos a la función login del contexto para guardar todo y actualizar el estado global
      login(data);

    } catch (error: any) {
      console.error("Error en el login:", error.message);
      setLoginError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // --- FUNCIÓN DE REGISTRO (sin cambios funcionales, ya estaba bien) ---
  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setRegisterError('');
    setUsernameError('');
    setRegisterSuccess('');

    if (!fullName || !registerEmail || !registerPassword) {
      setRegisterError('Por favor, completa todos los campos con un formato válido.');
      return;
    }

    setIsLoading(true);
    try {
      const phoneNumber = `${countryCode}${phone}`;
      const requestBody = {
        full_name: fullName,
        username: registerEmail,
        email: registerEmail,
        password: registerPassword,
        phone_number: phoneNumber,
        role: "user"
      };
      
      const response = await fetch(API_ENDPOINTS.register, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      if (!response.ok) {
        if (typeof data === 'object' && data !== null) {
          const errorMessages = Object.values(data).flat().join(' ');
          throw new Error(errorMessages || 'Error en el registro.');
        }
        throw new Error(data.detail || 'Ocurrió un error al registrar la cuenta.');
      }

      setRegisterSuccess('¡Cuenta creada con éxito! Por favor, inicia sesión.');
      setFullName('');
      setPhone('');
      setRegisterEmail('');
      setRegisterPassword('');
      setActiveTab('login');
      setRegistrationStep('plans'); 
      setSelectedPlan(null);  
    } catch (error: any) {
      setRegisterError(error.message);
    } finally {
      setIsLoading(false);
    }
  };


// --- NUEVA FUNCIÓN PARA RECUPERAR CONTRASEÑA ---
   const handleForgotPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setStatusMessage('');

    try {
      console.log("Enviando solicitud de recuperación a la API:", API_ENDPOINTS.forgotPassword);
      const response = await fetch(API_ENDPOINTS.forgotPassword, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: recoveryEmail }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || 'No se pudo procesar la solicitud.');
      
      setStatusMessage('Si existe una cuenta con ese correo, recibirás un enlace de recuperación pronto.');
      toast.success('Solicitud enviada.');
    } catch (error: any) {
      setStatusMessage(error.message);
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // --- LÓGICA DE "RESTABLECER CONTRASEÑA" ---
  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setStatusMessage('Las contraseñas no coinciden.');
      toast.error('Las contraseñas no coinciden.');
      return;
    }
    if (!token) {
        setStatusMessage('Token de recuperación no válido o expirado.');
        return;
    }

    setIsLoading(true);
    setStatusMessage('');
    
    try {
      const response = await fetch(API_ENDPOINTS.resetPassword, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: newPassword }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || 'No se pudo restablecer la contraseña.');

      setStatusMessage('¡Contraseña actualizada con éxito! Ahora puedes iniciar sesión.');
      toast.success('¡Contraseña actualizada!');
      // Esperamos un poco y volvemos al login
      setTimeout(() => {
          setView('default');
          setStatusMessage('');
          // Limpiamos la URL para que el token no quede visible
          window.history.pushState({}, '', window.location.pathname);
      }, 2000);

    } catch (error: any) {
      setStatusMessage(error.message);
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  // --- JSX (sin cambios funcionales) ---
  

 return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <div className="logo">🧠</div>
          <h1>{process.env.REACT_APP_COMPANY_NAME}</h1>
        </div>
        
        <LoginViews
          // Props generales
          view={view}
          setView={setView}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          isLoading={isLoading}
          statusMessage={statusMessage}
          setStatusMessage={setStatusMessage}

          // Props para Login
          loginUsername={loginUsername}
          setLoginUsername={setLoginUsername}
          loginPassword={loginPassword}
          setLoginPassword={setLoginPassword}
          handleLogin={handleLogin}
          loginError={loginError}
          registerSuccess={registerSuccess}

          // --- PROPS PARA REGISTRO (AQUÍ ESTÁ LA CORRECCIÓN) ---
          handleRegister={handleRegister}
          registerError={registerError}
          fullName={fullName}
          setFullName={setFullName}
          countryCode={countryCode}
          setCountryCode={setCountryCode}
          phone={phone}
          setPhone={setPhone}
          registerEmail={registerEmail}
          setRegisterEmail={setRegisterEmail}
          registerPassword={registerPassword}
          setRegisterPassword={setRegisterPassword}
          countryCodes={countryCodes}

          // Props para el nuevo flujo de registro
          registrationStep={registrationStep}
          setRegistrationStep={setRegistrationStep}
          selectedPlan={selectedPlan}
          handlePlanSelection={handlePlanSelection}
          plans={plans}

          // Props para Recuperación
          handleForgotPassword={handleForgotPassword}
          handleResetPassword={handleResetPassword}
          recoveryEmail={recoveryEmail}
          setRecoveryEmail={setRecoveryEmail}
          newPassword={newPassword}
          setNewPassword={setNewPassword}
          confirmPassword={confirmPassword}
          setConfirmPassword={setConfirmPassword}
        />
      </div>
    </div>
  );
};

export default LoginScreen;